import { defineStore } from 'pinia';
import { ref } from 'vue';
import devStorage from '@/services/DevOverlay/DevStorage';

const useDevOverlayStore = defineStore('devOverlay', () => {
  const toolsGroups = [
    'configs',
    'featureFlags',
  ] as const;

  type ToolGroupKey = typeof toolsGroups[number];

  const initialToolsGroup = toolsGroups[0];
  const currentToolsGroup = ref<ToolGroupKey>(initialToolsGroup);

  const toolGroupsTitles: Record<ToolGroupKey, string> = {
    configs: 'Configurações',
    featureFlags: 'Feature flags',
  };

  const config = ref(devStorage.get().config);
  config.value.apply();

  const reloadConfig = () => {
    config.value = devStorage.get().config;
  };

  const saveConfig = () => {
    config.value.apply();
    devStorage.set({ config: config.value });
  };

  const reset = () => {
    currentToolsGroup.value = initialToolsGroup;
  };

  return {
    currentToolsGroup,
    toolsGroups,
    toolGroupsTitles,
    config,

    reloadConfig,
    saveConfig,
    reset,
  };
});

export default useDevOverlayStore;
